import { AnbUIService } from '@anb/ng-ui';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationConfigCacheService } from 'app/modules/_core/services/application-config-cache.service';
import { ROUTE, RouteService } from 'app/modules/_core/services/route.service';
import { Observable } from 'rxjs';
import { AanvraagClient, CreateAanvraagRequest, OverzichtClient, OverzichtDTO } from '../../modules/_core/api/proxy';

@Component({
  selector: 'app-overzicht',
  templateUrl: './overzicht.component.html',
  styleUrls: ['./overzicht.component.css'],
})
export class OverzichtComponent implements OnInit {
  aanvragenOverzicht$: Observable<OverzichtDTO[]>;
  isIndieningActief$: Observable<boolean>;

  ROUTE = ROUTE;

  constructor(
    private _router: Router,
    private _routeService: RouteService,
    private _aanvraagClient: AanvraagClient,
    private _location: Location,
    private _overzichtClient: OverzichtClient,
    private _anbUIService: AnbUIService,
    private _applicationConfigCacheService: ApplicationConfigCacheService,
  ) {}

  ngOnInit() {
    this.loadOverzicht();
    this.isIndieningActief$ = this._applicationConfigCacheService.isIndieningActief;
  }

  private loadOverzicht(): void {
    this.aanvragenOverzicht$ = this._overzichtClient.getOverzicht();
  }

  deleteAanvraag(aanvraagId: string): void {
    this._anbUIService
      .showConfirmDialog('Aanvraag verwijderen?', 'Ben je zeker dat je deze aanvraag wil verwijderen?', 'Ja', 'Nee')
      .subscribe((value: boolean) => {
        if (value) {
          this._aanvraagClient.deleteAanvraag(aanvraagId).subscribe(() => {
            this.loadOverzicht();
          });
        }
      });
  }

  openDetail(aanvraagId: string): void {
    const route = this._routeService.getStappenplanRoute(aanvraagId);
    const urlTree = this._router.createUrlTree(route); // TODO : take a look at this
    const url = this._router.serializeUrl(urlTree);
    // Workaround for state reset of WorkflowService & AanvraagService. This services are singleton
    window.location.href = this._location.prepareExternalUrl(url);
  }
  startAanvraag() {
    this._aanvraagClient.createAanvraag(new CreateAanvraagRequest()).subscribe((reponse) => {
      this._router.navigate(this._routeService.getStappenplanRoute(reponse.id));
    });
  }
}
